import React from "react";
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import "./CertificatePreviewModal.css";

const CertificatePreviewModal = ({
  open,
  onClose,
  certificateImage,
  onDownloadClick,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        className: "certificate-preview-modal",
      }}
    >
      <div className="certificate-preview-container">
        <div className="certificate-preview-close" onClick={onClose}>
          <CloseIcon />
        </div>

        <h3 className="certificate-preview-title">Certificate Preview</h3>

        <div className="certificate-preview-wrapper-small">
          <img
            src={certificateImage}
            alt="Certificate"
            className="certificate-preview-image-small"
          />
        </div>

        <button
          className="certificate-btn-golden-download-inline"
          onClick={() => {
            onClose();
            onDownloadClick();
          }}
        >
          <DownloadIcon sx={{ fontSize: 22 }} />
          Download Certificate
        </button>
      </div>
    </Dialog>
  );
};

export default CertificatePreviewModal;
